/* eslint-disable react/jsx-no-target-blank */
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import React from 'react'
import {useLocalStorage} from '../../../../app/utils'

interface ARRAY_JSON_CHILD extends Array<JSON_CHILD> {}

interface JSON_CHILD {
  to: string
  title: string
  hasBullet: boolean
  code: string
  closeMenu?: boolean
  childrens?: ARRAY_JSON_CHILD
}

interface ARRAY_JSON extends Array<JSON> {}

interface JSON {
  to: string
  icon: string
  title: string
  code: string
  fontIcon: string
  childrens?: ARRAY_JSON_CHILD
}

export function AsideMenuMain() {
  const [menu] = useLocalStorage<ARRAY_JSON>('menu', [])
  const handleClick = (closeMenu: boolean | undefined) => {
    if (closeMenu) {
      document.body.setAttribute('data-kt-aside-minimize', 'on')
    }
  }

  // const menu = [
  //   {
  //     to: '/dashboard',
  //     icon: '/media/icons/duotune/art/art002.svg',
  //     title: 'Trang chủ',
  //     code: '',
  //     fontIcon: 'bi-app-indicator',
  //   },
  //   {
  //     to: '#',
  //     icon: '/media/icons/duotune/general/gen022.svg',
  //     title: 'Khách hàng/Đối tác',
  //     code: 'clientpartner',
  //     fontIcon: 'bi-archive',
  //     childrens: [
  //       {
  //         to: '/crafted/partners/customers',
  //         title: 'Thông tin khách hàng',
  //         code: 'clientinformation',
  //         hasBullet: true,
  //       },
  //       {
  //         to: '/crafted/partners/partners',
  //         title: 'Thông tin đại lý/đối tác',
  //         hasBullet: true,
  //         code: 'partnerinformation',
  //       },
  //     ],
  //   },
  //   {
  //     to: '/crafted/insurance',
  //     icon: '/media/icons/duotune/general/gen025.svg',
  //     title: 'Hợp đồng bảo hiểm',
  //     code: 'insurancecontract',
  //     fontIcon: 'bi-archive',
  //     childrens: [
  //       {
  //         to: '/crafted/insurance/person-insurance-coop',
  //         title: 'Bảo hiểm con người',
  //         closeMenu: true,
  //         hasBullet: true,
  //         code: 'healthinsurance',
  //       },
  //       {
  //         to: '/crafted/insurance/person-insurance-retail',
  //         title: 'Bảo hiểm con người - bán lẻ',
  //         closeMenu: true,
  //         hasBullet: true,
  //         code: '',
  //       },
  //       {
  //         to: '/crafted/insurance/auto-insurance',
  //         title: 'Bảo hiểm ô tô',
  //         closeMenu: true,
  //         hasBullet: true,
  //         code: 'autoinsurance',
  //       },
  //       {
  //         to: '/crafted/insurance/moto-insurance',
  //         title: 'Bảo hiểm xe máy',
  //         closeMenu: true,
  //         hasBullet: true,
  //         code: 'motoinsurance',
  //       },
  //       {
  //         to: '#',
  //         title: 'Bảo hiểm tài sản',
  //         hasBullet: true,
  //         code: '',
  //       },
  //       {
  //         to: '#',
  //         title: 'Bảo hiểm kỹ thuật',
  //         hasBullet: true,
  //         code: '',
  //       },
  //       {
  //         to: '#',
  //         title: 'Bảo hiểm hàng hoá',
  //         hasBullet: true,
  //         code: '',
  //       },
  //       {
  //         to: '#',
  //         title: 'Bảo hiểm tàu thuyền',
  //         hasBullet: true,
  //         code: '',
  //       },
  //       {
  //         to: '#',
  //         title: 'Bảo hiểm trách nhiệm',
  //         hasBullet: true,
  //         code: '',
  //       },
  //       {
  //         to: '#',
  //         title: 'Bảo hiểm hỗn hợp',
  //         hasBullet: true,
  //         code: '',
  //       },
  //     ],
  //   },
  //   {
  //     to: '#',
  //     icon: '/media/icons/duotune/communication/com012.svg',
  //     title: 'Đối soát, thanh toán',
  //     fontIcon: 'bi-chat-left',
  //     code: 'checkpayment',
  //     childrens: [
  //       {
  //         to: '/crafted/payments/fee',
  //         title: 'Thanh toán phí bảo hiểm',
  //         hasBullet: true,
  //         code: '',
  //       },
  //       {
  //         to: '/crafted/payments/commission',
  //         title: 'Thanh toán hoa hồng',
  //         hasBullet: true,
  //         code: '',
  //       },
  //       {
  //         to: '/crafted/payments/Cancellation',
  //         title: 'Hủy hợp đồng',
  //         hasBullet: true,
  //         code: '',
  //       },
  //     ],
  //   },

  //   {
  //     to: '/crafted/report',
  //     icon: '/media/icons/duotune/communication/com006.svg',
  //     title: 'Phê duyệt',
  //     fontIcon: 'bi-person',
  //     code: 'approval',
  //   },
  // ]

  const RenderMenu = (menu: ARRAY_JSON) => {
    var test = menu.map((obj, index) => (
      <React.Fragment key={index}>
        {obj.childrens ? (
          <AsideMenuItemWithSub
            to={obj.to}
            icon={obj.fontIcon}
            title={obj.title}
            fontIcon={obj.fontIcon}
          >
            {RenderSubMenu(obj.childrens)}
          </AsideMenuItemWithSub>
        ) : (
          <AsideMenuItem
            onClick={() => {
              if (obj.to == '/crafted/report') handleClick(true)
            }}
            to={obj.to}
            icon={obj.fontIcon}
            title={obj.title}
            fontIcon={obj.fontIcon}
          />
        )}
      </React.Fragment>
    ))

    return <>{test}</>
  }

  const RenderSubMenu = (arrChild: ARRAY_JSON_CHILD) => {
    var test = arrChild.map((obj, index) => (
      <React.Fragment key={index}>
        {obj.childrens ? (
          <AsideMenuItemWithSub to={obj.to} title={obj.title} hasBullet={obj.hasBullet}>
            {obj.childrens &&
              obj.childrens.map((childObj, childIndex) => (
                <React.Fragment key={childIndex}>
                  {childObj.childrens ? (
                    <>{RenderSubMenu(childObj.childrens)}</>
                  ) : (
                    <AsideMenuItem
                      onClick={() => handleClick(obj.closeMenu)}
                      to={childObj.to}
                      title={childObj.title}
                      hasBullet={childObj.hasBullet}
                    />
                  )}
                </React.Fragment>
              ))}
          </AsideMenuItemWithSub>
        ) : (
          <AsideMenuItem
            onClick={() => handleClick(obj.closeMenu)}
            to={obj.to}
            title={obj.title}
            hasBullet={obj.hasBullet}
          />
        )}
      </React.Fragment>
    ))
    return <>{test}</>
  }

  return <>{RenderMenu(menu)}</>
}
